// extracted by mini-css-extract-plugin
module.exports = {"textModalBody":"text-modal-body_component_textModalBody__a5F6t"};